import { useState } from "react";
import DefaultButton from "../components/DefaultButton";
import { BsArrowCounterclockwise } from "react-icons/bs";
import ghost from "../assets/tris/ghost.png";
import x from "../assets/tris/x.png";
import o from "../assets/tris/o.png";
      
const WINNING_COMBINATIONS = [
  [0,1,2],
  [3,4,5],
  [6,7,8],
  [0,3,6],
  [1,4,7],
  [2,5,8],
  [0,4,8],
  [2,4,6]
];

export default function NotFound() {

  const [board, setBoard] = useState(Array(9).fill(null));
  const [winner, setWinner] = useState(null);    
  const playerWon = winner === "X";
  const computerWon = winner === "O";
  // const gameOver = winner !== null;
  // const draw = winner === "draw";

  const draw =
      winner === null &&
      board.every(cell => cell !== null);

  const gameOver =
      playerWon ||
      computerWon ||
      draw;
      
  // useEffect(() => {
  //   // crea stato nella history
  //   window.history.pushState(null, "", window.location.href);

  //   const handlePopState = () => {
  //       resetGame();
  //       // blocca uscita e rimetti la pagina immediatamente
  //       window.history.pushState(null, "", window.location.href);
  //   };

  //   window.addEventListener("popstate", handlePopState);

  //   return () => {
  //       window.removeEventListener("popstate", handlePopState);
  //   };
  // }, []);
              
  function getWinner(cells) {
      for (const [a,b,c] of WINNING_COMBINATIONS) {
          if (
              cells[a] &&
              cells[a] === cells[b] &&
              cells[a] === cells[c]
          ) {
              return cells[a];
          }
      }
      return null;
  }
      
  function handleClick(index) {
      if (board[index] || gameOver) return;

      const newBoard = [...board];
      newBoard[index] = "X";

      const win = getWinner(newBoard);
  
      setBoard(newBoard);

      // X vince
      if (win) {
          setWinner("X");
          return;
      }
      // pareggio / nessun vincitore
      if (newBoard.every(cell => cell !== null)) {
          return;
      }

      setTimeout(() => {
          computerMove(newBoard);
      }, 400);
  }
      
  function computerMove(currentBoard) {
      if (gameOver) return;

      const empty = currentBoard
          .map((c, i) => (c === null ? i : null))
          .filter(v => v !== null);

      if (!empty.length) return;

      const move = empty[Math.floor(Math.random() * empty.length)];

      const newBoard = [...currentBoard];
      newBoard[move] = "O";

      const win = getWinner(newBoard);

      setBoard(newBoard);

      if (win) {
          setWinner("O");
          return;
      }
  }

  function resetGame() {
      setBoard(Array(9).fill(null));
      setWinner(null);
  }


  console.log("NOT FOUND montata")

  return (
    <div className="text-white flex flex-col items-center justify-center min-h-screen h-full w-full mx-auto gap-3">
      <h2 className="lg:text-7xl text-5xl font-bold tracking-wider">404</h2>
      <p className="lg:text-3xl text-2xl italic">Pagina non trovata</p>

        <div className="flex flex-col items-center justify-center gap-8 mt-10">
          {!playerWon && !computerWon && !draw && (
              <p className="mb-12">✨ Ma hai trovato un gioco! ✨</p>
          )}

          {playerWon && (
              <div className="bubble-speech mb-4">
                  <p className="text-center px-2">
                  Hai vinto! 🎉<br/>
                  Te si sta brao.
                  </p>
              </div>
          )}

          {computerWon && (
              <div className="bubble-speech mb-2">
                  <p className="text-center px-2">
                  Hai perso! 😈<br/>
                  Che scarso
                  </p>
              </div>
          )}

          {draw && (
              <div className="bubble-speech mb-4">
                  <p className="text-center px-2">
                  Nessun vincitore 🙅‍♀️
                  </p>
              </div>
          )}

          <div className="relative">
              <img src={ghost} alt="mascotte" className="w-20 absolute bottom-full right-5 bouncing-animation" />

              <div className="grid grid-cols-3 grid-rows-3 gap-0 border border-white/20">
                  {board.map((cell,index) => (
                      <button
                          key={index}
                          className="flex items-center justify-center w-[100px] h-[100px] text-3xl cursor-pointer border border-white/20"
                          onClick={() => handleClick(index)}>
                          {cell === "X" && <img src={x} alt="X" className="w-9 h-9" />}
                          {cell === "O" && <img src={o} alt="O" className="w-10 h-10" />}
                      </button>
                  ))}
              </div>
          </div>

          <div className="flex flex-col gap-10 items-center w-full">
              <button onClick={resetGame} 
              className="inline-flex items-center gap-2 w-fit uppercase panoragraf-light tracking-wider rounded-full 
              border border-red-500 text-red-500 px-8 py-2 hover:bg-red-500 hover:text-white transition-all duration-300">
                  rigioca
                  <BsArrowCounterclockwise size={20} />
              </button>

              {playerWon && (
                  <DefaultButton text="Torna alla home" link="/" buttonClass="lg:w-full" />
              )}
          </div>
        </div> 
    </div>
  );
}